import { FormattedMessage } from 'react-intl';

import { JobCard } from '../cards/job-card';
import { DeckCardContextProvider } from '../context';

import {
  ModalPage,
  CardContainer,
  ReminderLabel,
  ReminderLabelDescription,
  // ReminderCta,
  CloseButton,
  Content,
} from './card-modal.styled';
import { useModalData } from './use-modal-data';

type CardModalProps = {
  cardId: string;
  show: boolean;
  setShow: (show: boolean) => void;
};

export const CardModal: React.FC<CardModalProps> = ({
  cardId,
  show,
  setShow,
}) => {
  const { jobCardData, alertId } = useModalData(cardId || '', show);

  if (!jobCardData) {
    return null;
  }

  return (
    <ModalPage
      closeButton={{ onClick: () => setShow(false) }}
      isAnimated
      isShown={!!show}
      noGrid
      noMargin
    >
      <Content>
        <DeckCardContextProvider
          card={{ type: 'TakenJob', data: jobCardData }}
          deckIndex={-1}
        >
          <CardContainer>
            <JobCard data={{ ...jobCardData, type: 'TakenJob' }} />
          </CardContainer>
        </DeckCardContextProvider>
        <ReminderLabel size="xxlarge">
          <FormattedMessage
            id={
              alertId !== undefined
                ? 'SEARCH_AND_SHUFFLE_MODAL_REMINDER_ENABLED'
                : 'SEARCH_AND_SHUFFLE_MODAL_REMINDER_DISABLED'
            }
          />
        </ReminderLabel>
        <ReminderLabelDescription size="medium" lineHeight="increased">
          <FormattedMessage
            id={
              alertId !== undefined
                ? 'SEARCH_AND_SHUFFLE_MODAL_REMINDER_ENABLED_DESCRIPTION'
                : 'SEARCH_AND_SHUFFLE_MODAL_REMINDER_DISABLED_DESCRIPTION'
            }
          />
        </ReminderLabelDescription>
        {/* <ReminderCta
          size="medium"
          variant={alertId !== undefined ? 'onColor' : 'onColorStrong'}
        >
          <FormattedMessage
            id={
              alertId !== undefined
                ? 'SEARCH_AND_SHUFFLE_MODAL_REMINDER_ENABLED_CTA'
                : 'SEARCH_AND_SHUFFLE_MODAL_REMINDER_DISABLED_CTA'
            }
          />
        </ReminderCta>*/}
        <CloseButton onClick={() => setShow(false)} size="medium">
          <FormattedMessage id="SEARCH_AND_SHUFFLE_MODAL_CLOSE" />
        </CloseButton>
      </Content>
    </ModalPage>
  );
};
